import BaseMessageHandler from '../BaseMessageHandler';
import { updatePermissions } from 'actions/permissions';

export default class MessagesPermissions extends BaseMessageHandler {
  default = () => {
    const { dispatch, message } = this;
    dispatch(updatePermissions(message.payload));
  };
}
